import { keepPreviousData, useQuery } from '@tanstack/react-query'
import {
  getCompanyFinancialsTable,
  type CompanyFinancialsScenarioType,
  type CompanyFinancialsTrailingPeriod,
} from '@/services/companies.service'

type BaseFinancialsParams = {
  scenarioType: CompanyFinancialsScenarioType
  trailingPeriod: CompanyFinancialsTrailingPeriod
  showBlankPeriods: boolean
  asOfDate?: string
}

type FinancialsParams =
  | (BaseFinancialsParams & { view: 'MONTHLY'; months?: number })
  | (BaseFinancialsParams & { view: 'QUARTERLY'; quarters?: number })
  | (BaseFinancialsParams & { view: 'ANNUAL'; years?: number })

export function useCompanyFinancialsTable(
  companyId: string,
  params: FinancialsParams
) {
  return useQuery({
    queryKey: ['company-financials-table', companyId, params],
    queryFn: () => getCompanyFinancialsTable(companyId, params),
    enabled: Boolean(companyId),
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
  })
}
